import { render, staticRenderFns } from "./AgeGroupText.vue?vue&type=template&id=0b1a41e6"
import script from "./AgeGroupText.vue?vue&type=script&lang=js"
export * from "./AgeGroupText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports